/* eslint-disable complexity */
import './styles.css';

import React, {
    Fragment,
    useEffect,
    useRef,
    useState,
    // useMemo
} from 'react';
import { Typography } from '@vtblife/uikit';

import { FixedHeightBanner } from '@vtblife/media-kit/dist/banners/fixed-height-banner/fixed-height-banner';
import { checkRegionIsPromoSamolet } from '@search/vtbeco-frontend-core/dict/samolet-regions';
import { getBannerConfig, BannerType } from '@search/vtbeco-frontend-core/dict/samolet-banner-config';

import { errorCatcherWrap } from '@search/error/src/catcher';
import { ProfRealityObject } from '@search/graphql-typings';
import { pickRandom } from '@search/helpers/src/newbuilding-promo';
import { ClassifiedAnalytics } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedAnalytics';
import { OfferSnippetModel } from '@search/vtbeco-frontend-core/domain/offer/search/page/SearchOffersQuery';
import { DeveloperPromoBanner } from '@search/vtbeco-frontend-core/domain/newbuilding/developer-promo/types';
import useDeveloperPromo from '@search/vtbeco-frontend-core/domain/newbuilding/developer-promo/useDeveloperPromo';
import { getDeveloperBannerGtmData } from '@search/vtbeco-frontend-core/domain/newbuilding/developer-promo/analytics';
import { RegionIdEnum } from '@search/vtbeco-frontend-core/enums';
// import { GuaranteedDealFakeOfferSnippet } from '@search/vtbeco-frontend-core/view/common/components/GuaranteedDeal/GuaranteedDealFakeOfferSnippet';
import NewBuildingPromoBanner from '@search/vtbeco-frontend-core/view/desktop/components/NewBuildingPromoBanner';
import classname from '@search/classname/src';
// import { OnlinePurchaseSerpBanner } from '@search/vtbeco-frontend-core/view/common/components/OnlinePurchaseSerpBanner/OnlinePurchaseSerpBanner';
import { SimilarNewBuildingOffersSection } from '@search/classified-common/src/SimilarNewBuildingOffers/SimilarNewBuildingOffersSection';
// import { MortgageInRentOffers } from '@search/classified-common/src/MortgageInRentOffers/MortgageInRentOffers';
import { YandexBanner } from '@search/classified-common/src/YandexBanner/YandexBanner';
// import { ClBanners } from '@search/vtbeco-frontend-core/view/common/components/Banners';
import { SearchRoute } from '@search/offer-search-routes/src';
import { useRouter } from '@search/offer-search-routes/src';
import { NewBuilding } from '@search/filter-enums/enums/NewBuilding';

import { ClassifiedOfferGtmContext } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import { ImageLazySrcSetProvide, useClImageLazySrcSetUrl } from '@search/vtbeco-frontend-core/domain/image/lazy/ImageLazySrcSet';
import { createOfferGtm2Context } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import { ClEmptySearch } from '@search/classified-common/src/ClEmptySearch/ClEmptySearch';
import Image from '@search/vtbeco-frontend-core/view/common/components/Image';
import EmptySearchIcon from '@search/classified-common/src/ClEmptySearch/emptySearch.url.svg';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';
import { getRegionForPromo } from '@search/classified-common/src/ClShellProvider/ClHeader';
import MockSnippet from '../../Snippet/MockSnippet';
import { OfferSnippet } from '../../Snippet/OfferSnippet';

// import { useGeoRootRegion } from '@search/geo/src/GeoRootRegionProvider';

const NewBuildingPromoBannerWithCatcher = React.memo(errorCatcherWrap(NewBuildingPromoBanner));

const cn = classname.bind(null, 'OffersSearchList');

const nbDataGtm = { click: ClassifiedAnalytics.SearchBanner };

export const OffersSearchList = (errorCatcherWrap(({
    onResetFilters,
    loading,
    collection,
    emptyResultTitle,
    regionId,
    narrowRegionId,
    isSell,
    isNewBuilding,
    realtyType,
    isCreatedAtVisible,
    isRealtorAuthorFilterActive,
    userId,
    disableIdle,
    openSaveSearch,
    onSwitchToNb,
    similarNbCollection,
    showPromoRieltors
}: {
    disableIdle?(): void;
    loading: boolean;
    collection: readonly OfferSnippetModel[];
    similarNbCollection?: readonly OfferSnippetModel[];
    onResetFilters: () => void;
    openSaveSearch: () => void;
    onSwitchToNb: () => void;
    regionId: RegionIdEnum;
    narrowRegionId?: number;
    isSell: boolean;
    isNewBuilding?: boolean;
    realtyType: NonNullable<ProfRealityObject['__typename']>;
    emptyResultTitle: string;
    isRealtorAuthorFilterActive: boolean;
    isCreatedAtVisible?: boolean;
    hasOfferWithoutVas: boolean;
    userId: string;
    showPromoRieltors: boolean;
    isOnlySecondOffers: boolean;
    pageNumber: number;
}) => {
    const staticPath = useStaticPathConfig();

    const listRef = useRef<HTMLUListElement | null>(null);
    const [ newBuildingPromo, setNewBuildingPromo ] = useState<DeveloperPromoBanner | undefined>();

    const {
        name: developerWithPromoName,
        config: developerPromoConfig
    } = useDeveloperPromo(getRegionForPromo(regionId, narrowRegionId));

    useEffect(() => {
        if (! isSell || ! developerPromoConfig) {
            return;
        }

        if (developerWithPromoName === 'samolet') {
            setNewBuildingPromo(pickRandom(developerPromoConfig.promos.banner));
        }
    }, [ developerPromoConfig, collection, isSell, developerWithPromoName ]);

    const isEmpty = collection.length === 0;

    // const rootRegion = useGeoRootRegion();
    // const regionLocativeFormatted = rootRegion.byId(regionId)?.locative ?? undefined;
    const getUrl = useClImageLazySrcSetUrl({ baseUrl: collection?.[0]?.gallery?.baseUrl });

    const isSellMixedSecondFlat = ! isNewBuilding && realtyType === 'ProfOfferFlat' && isSell;
    // const isRentFlat = realtyType === 'ProfOfferFlat' && ! isSell;
    const isYandexBanner = false; // RS-7201: ya-banners disabling
    // const isYandexBanner = realtyType !== 'ProfOfferFlat' || ! isSell;
    // const bannerPlacement = useMemo(() => {
    //     switch (realtyType) {
    //         case 'ProfOfferFlat':
    //         case 'ProfOfferRoom':
    //             if (isNewBuilding) return 'newbuilding';
    //             return 'second';
    //         case 'ProfOfferHouse':
    //             return 'house';
    //         case 'ProfOfferLand':
    //             return 'land';
    //         default:
    //             return 'second';
    //     }
    // }, [ isNewBuilding, realtyType ]);

    const router = useRouter();
    const searchRoute = router.route(SearchRoute);
    const searchParams = searchRoute.params();
    const newBuildingUrl = searchRoute.url({ ...searchParams, newBuilding: [ NewBuilding.NEW ] });

    const isSamoletRegion = checkRegionIsPromoSamolet(regionId);
    const banner1 = getBannerConfig(BannerType.CL_SEARCH_1_DESKTOP);
    const banner2 = getBannerConfig(BannerType.CL_SEARCH_2_DESKTOP);

    return (<>
        {! loading && (emptyResultTitle || isEmpty) ? (
            <ClEmptySearch
                openSaveSearch={openSaveSearch}
                onResetFilters={onResetFilters}
                showPromoRieltors={showPromoRieltors}
                renderIcon={<Image url={`${staticPath}${EmptySearchIcon}`} />}
                regionId={regionId}
            />
        ) : null}
        {! loading && ! isEmpty && emptyResultTitle ? (
            <Typography variant='h3'>{emptyResultTitle}</Typography>
        ) : null}
        <ul ref={listRef} className={cn('list', { overlay: loading && ! isEmpty })} data-test='offers'>
            {loading && isEmpty ?
                [ 1, 2, 3, 4, 5 ].map(
                    (_, idx) => <li className={cn('item', { hasSnippetStyle: true })} key={idx}>
                        <MockSnippet />
                    </li>
                ) :
                // eslint-disable-next-line complexity
                collection.map((offer, index) => {
                    const isFlat = offer.realtyObject?.__typename === 'ProfOfferFlat';
                    const isRoom = offer.realtyObject?.__typename === 'ProfOfferRoom';
                    let banner;

                    if (
                        index === 0 &&
                        ! isRealtorAuthorFilterActive &&
                        isSell && (isFlat || isRoom) &&
                        developerWithPromoName && developerPromoConfig
                    ) {
                        banner = newBuildingPromo ? (
                            <NewBuildingPromoBannerWithCatcher
                                view='offer'
                                id={newBuildingPromo.id}
                                disclaimerList={newBuildingPromo.disclaimer ?? []}
                                developerName={developerWithPromoName}
                                developerLogo={developerPromoConfig.logo.color}
                                dataGTM={nbDataGtm}
                                gtmClickData={getDeveloperBannerGtmData(developerWithPromoName, {
                                    action: 'click',
                                    section: 'promo_block',
                                    pageType: 'serp'
                                })}
                                gtmShowData={getDeveloperBannerGtmData(developerWithPromoName, {
                                    action: 'view',
                                    section: 'promo_block',
                                    pageType: 'serp'
                                })}
                                erid={newBuildingPromo.erid}
                            />
                        ) : (<div
                            style={{
                                height: 160
                            }}
                        >&nbsp;</div>);
                    }

                    if (index === 0 && isYandexBanner) {
                        banner = (<YandexBanner variant='search-desk' />);
                    }

                    // if (index === 4 && ! isRealtorAuthorFilterActive && showMortgageBanner) {
                    //     banner = (<Mortgage3StarterBanner
                    //         locationPlacement='промо-баннер'
                    //         applicationId={ApplicationIdEnum.ClassifiedDesktop}
                    //         regionId={regionId}
                    //         realtyType={realtyType}
                    //         gtmSendId={ClassifiedAnalytics.SearchSaleIpotekaBannerSend}
                    //         gtmShowId={ClassifiedAnalytics.SearchSaleIpotekaBannerShow}
                    //         isNewBuilding={! isOnlySecondOffers}
                    //         // withoutAuth
                    //         // purpose={mortgagePurpose}
                    //         // estimatePrice={estimatePrice}
                    //         // regionLocativeFormatted={regionLocativeFormatted}
                    //         // mortgageBannerMinutesVariant={mortgageBannerMinutesVariant}
                    //         // mortgageBannerTextVariant={mortgageBannerTextVariant}
                    //     />);
                    // }
                    //
                    // if (index === 14 && ! isRealtorAuthorFilterActive && isSellMixedSecondFlat) {
                    //     banner = <GuaranteedDealFakeOfferSnippet />;
                    // }
                    //
                    // if (index === 8 && ! isRealtorAuthorFilterActive &&
                    //     ! hasOfferWithoutVas && isSellMixedSecondFlat) {
                    //     banner = <OnlinePurchaseSerpBanner />;
                    // }
                    // if (index === 0 && (pageNumber === 1 || pageNumber % 3 === 0)) {
                    //     banner = (<ClBanners
                    //         placement={bannerPlacement}
                    //         type={realtyType === 'ProfOfferLand' ? 'izhs' : 'mortgage'}
                    //         minimalMortgageRate={minimalMortgageRate}
                    //     />);
                    // }
                    //
                    // if (index === 7 && (pageNumber === 1 || pageNumber % 3 === 0)) {
                    //     banner = (<ClBanners
                    //         placement={bannerPlacement}
                    //         type={realtyType === 'ProfOfferLand' ? 'mortgage' : 'izhs'}
                    //         minimalMortgageRate={minimalMortgageRate}
                    //     />);
                    // }
                    //
                    // if (index === 13 && (pageNumber === 1 || pageNumber % 3 === 0) && isSellMixedSecondFlat) {
                    //     banner = (<ClBanners
                    //         placement={bannerPlacement}
                    //         type='save'
                    //     />);
                    // }

                    if (isSamoletRegion) {
                        if (index === 0) {
                            banner = (
                                <FixedHeightBanner
                                    placementId={banner1.placementId}
                                    group={banner1.group}
                                />
                            );
                        }
                        if (index === 7) {
                            banner = (
                                <FixedHeightBanner
                                    placementId={banner2.placementId}
                                    group={banner2.group}
                                />
                            );
                        }
                    }

                    const mixedNewBuildingBlock = isSellMixedSecondFlat && similarNbCollection?.length &&
                        (index === 7 || (collection.length < 7 && index === collection.length - 1)) ? (
                            <SimilarNewBuildingOffersSection
                                onSwitchToNb={onSwitchToNb}
                                similarNbCollection={similarNbCollection}
                                newBuildingUrl={newBuildingUrl}
                            />
                        ) : null;

                    // const mortgageInRentOffers = isRentFlat &&
                    //     (index === 7 || (collection.length <= 7 && index === collection.length - 1)) ? (
                    //         <MortgageInRentOffers type='search' />
                    //     ) : null;

                    // не добавляйте здесь во фрагмент ключ, получается лишний полный ререндер у блоков/баннеров при смене страницы (если внутри них запрос - ещё и лишний запрос).
                    return (<>
                        <li className={cn('item', { hasHighlight: offer.status?.hasHighlight })} key={offer.id}>
                            <ClassifiedOfferGtmContext.Provider
                                value={createOfferGtm2Context({ place: 'serp', offer })}
                            >
                                <ImageLazySrcSetProvide getUrl={getUrl}>
                                    <OfferSnippet
                                        borderEnabled
                                        disableIdle={disableIdle}
                                        model={offer}
                                        userId={userId}
                                        index={index}
                                        isCreatedAtVisible={isCreatedAtVisible}
                                    />
                                </ImageLazySrcSetProvide>
                            </ClassifiedOfferGtmContext.Provider>
                        </li>
                        <Fragment key={index}>
                            {! isRealtorAuthorFilterActive && banner ?
                                <li className={cn('item')}>
                                    {banner}
                                </li> :
                                null
                            }
                            {/*{mortgageInRentOffers}*/}
                            {mixedNewBuildingBlock}
                        </Fragment>
                    </>);
                })
            }
        </ul>
    </>);
}));
